import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {createDivIn, createImgIn, createLinkIn, createParagraphIn, setElementInnerText} from '../../../shared/scripts/ui_utils/DomUtils'
import {NotificationContentType} from '../../../shared/scripts/ui_utils/NotificationUtils'

export class UICornerNotificationView {
    private readonly container: HTMLDivElement
    private readonly notification: HTMLDivElement
    private readonly contentContainer: HTMLDivElement
    private readonly crossImage: HTMLImageElement
    private timerContainer: HTMLDivElement | undefined
    private readonly text: HTMLParagraphElement | HTMLLinkElement
    private removeAction: (() => void) | undefined
    private readonly _isPermanent: boolean
    readonly contentType: NotificationContentType

    constructor(icon: LobbyImage, text: TranslationObject, duration: number, action?: () => void, removeAction?: () => void, isPermanent: boolean = false, contentType: NotificationContentType = NotificationContentType.General) {
        this.container = document.getElementById('corner-notification-container') as HTMLDivElement
        this.notification = createDivIn(this.container, 'corner-notification') as HTMLDivElement
        createImgIn(this.notification, icon, 'corner-notification-image') as HTMLImageElement
        this.contentContainer = createDivIn(this.notification, 'corner-notification-content-container') as HTMLDivElement
        this.text = UICornerNotificationView.createNotificationTextElement(this.contentContainer, text, action) as HTMLParagraphElement | HTMLLinkElement
        this.crossImage = createImgIn(this.contentContainer, LobbyImage.XMark, 'corner-notification-cross') as HTMLImageElement

        if(!isPermanent) this.createTimerAnimation(duration)

        this.notification.classList.add('slide-in')
        this.removeAction = removeAction
        this._isPermanent = isPermanent
        this.contentType = contentType

        this.crossImage.onclick = () => {
            this.close()
        }
    }

    get isPermanent() {
        return this._isPermanent
    }

    resetTimerAnimation(duration: number) {
        if(this.timerContainer == undefined) return
        this.notification.removeChild(this.timerContainer)
        this.createTimerAnimation(duration)
    }

    private createTimerAnimation(duration: number) {
        this.timerContainer = createDivIn(this.notification, 'corner-notification-timer-bg') as HTMLDivElement
        const horizontalTimerFill = createDivIn(this.timerContainer, 'corner-notification-timer-fill') as HTMLDivElement
        horizontalTimerFill.style.animation = `widthToZero ${duration}ms linear forwards`
    }

    close() {
        if(this.notification.parentElement == undefined) return
        if(this.removeAction != undefined) this.removeAction()
        this.notification.classList.add('fade-out')
        this.notification.addEventListener('transitionend', () => {
            if(this.notification.parentElement !== this.container) return
            this.container.removeChild(this.notification)
        }, {once: true})
    }

    updateText(newText: TranslationObject) {
        setElementInnerText(this.text, newText)
    }

    updateRemoveAction(removeAction: () => void) {
        this.removeAction = removeAction
    }

    private static createNotificationTextElement(container: HTMLElement, text: TranslationObject, action?: () => void): HTMLParagraphElement | HTMLLinkElement {
        const isTextLink = action !== undefined
        if(!isTextLink) return createParagraphIn(container, text, '')

        const linkElement = createLinkIn(container, '#', text, '')
        linkElement.onclick = (e: MouseEvent) => {
            e.preventDefault()
            action()
        }

        return linkElement
    }
}
